import React, { useState } from 'react';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { SimpleTooltip } from 'components';

// Browser-like steps; 1 is the report at its real (PDF) width.
export const ZOOM_LEVELS = [0.5, 0.67, 0.75, 0.8, 0.9, 1, 1.1, 1.25, 1.5, 1.75, 2];
const DEFAULT_ZOOM = 1;
const ZOOM_STORAGE_KEY = 'progressReportZoom';

const readStoredZoom = () => {
    try {
        const stored = Number(localStorage.getItem(ZOOM_STORAGE_KEY));
        return ZOOM_LEVELS.includes(stored) ? stored : DEFAULT_ZOOM;
    } catch (e) {
        return DEFAULT_ZOOM;
    }
};

/** Report zoom, remembered per browser so the next report opens at the same level. */
export const useReportZoom = () => {
    const [zoom, setZoomState] = useState(readStoredZoom);

    const setZoom = (next) => {
        setZoomState(next);
        try {
            localStorage.setItem(ZOOM_STORAGE_KEY, String(next));
        } catch (e) {
            // Storage blocked: zoom still works for this visit.
        }
    };

    const index = ZOOM_LEVELS.indexOf(zoom);
    return {
        zoom,
        canZoomIn: index < ZOOM_LEVELS.length - 1,
        canZoomOut: index > 0,
        zoomIn: () => setZoom(ZOOM_LEVELS[Math.min(index + 1, ZOOM_LEVELS.length - 1)]),
        zoomOut: () => setZoom(ZOOM_LEVELS[Math.max(index - 1, 0)]),
        resetZoom: () => setZoom(DEFAULT_ZOOM),
    };
};

export const ZoomControls = ({ zoom, canZoomIn, canZoomOut, zoomIn, zoomOut, resetZoom }) => (
    <div className="report-zoom-controls">
        <SimpleTooltip title={<p>Zoom out</p>} placement="bottom">
            <button type="button" className="report-zoom-btn" onClick={zoomOut} disabled={!canZoomOut} aria-label="Zoom out">
                <RemoveIcon fontSize="small" />
            </button>
        </SimpleTooltip>
        <SimpleTooltip title={<p>Reset to 100%</p>} placement="bottom">
            <button type="button" className="report-zoom-value" onClick={resetZoom} aria-label="Reset zoom">
                {`${Math.round(zoom * 100)}%`}
            </button>
        </SimpleTooltip>
        <SimpleTooltip title={<p>Zoom in</p>} placement="bottom">
            <button type="button" className="report-zoom-btn" onClick={zoomIn} disabled={!canZoomIn} aria-label="Zoom in">
                <AddIcon fontSize="small" />
            </button>
        </SimpleTooltip>
    </div>
);
